import axios from './index.js';

//获取网络表演个人信息
export let getUserNetInfo = (params) => {
    return axios.get(`/sys/user/net/info/${params}`);
};

//网络表演个人信息完善
export let putUserNetInfo = (params) => {
    return axios.put(`/sys/user/net/info`, params);
};

//检测个人信息
export let getEnrollCheckUser = () => {
    return axios.get(`/client/net/enroll/check/user`);
};

//检测报名条件
export let getEnrollCheckCert = (params) => {
    return axios.get(`/client/net/enroll/check/cert/${params}`);
};

//获取证书
export let getNetCertDetail = (params) => {
    return axios.get(`/client/net/cert/${params}`);
};

//报名
export let postNetEnroll = (params) => {
    return axios.get(`/client/net/enroll/${params}`);
};

//获取报名证书信息
export let getEnrollCertUser = () => {
    return axios.get(`/client/net/user/cert/cert/user`);
};

//获取报名证书信息
export let getEnrollCertUserEnroll = () => {
    return axios.get(`/client/net/enroll/cert/user/enroll`);
};

//获取已获得证书信息
export let getEnrollCertUserCert = () => {
    return axios.get(`/client/net/user/cert/cert/user/cert`);
};

//获取证书配置
export let getNetCertConfig = (params) => {
    return axios.get(`/client/net_cert_conf/queryTypeConf/${params}`);
};

//报名查询
export let getNetEnrollDetail = (params) => {
    return axios.get(`/client/net/enroll/enroll/${params}`);
};

//根据报名编号查询课程
export let getNetUserCourse = (params) => {
    return axios.get(`/net/client/user-course/userCourse/${params}`);
};

//获取线下培训信息
export let getNetUserTrainOffline = (params) => {
    return axios.get(`/client/net/user/train/offline/${params}/`);
};

//获取考试相关信息（科目，历史，报名）
export let getNetEnrollQueryExamInfo = (params) => {
    return axios.get(`/net/client/exam/queryExamInfo/${params}`);
};

//用户播放进度及学习记录
export let postNetCourseSourceSchedule = (params) => {
    return axios.post(`/net/client/user-course/source/schedule`, params);
};

//用户播放进度及学习记录
export let getNetCourseSourceSchedule = (params) => {
    return axios.get(`/net/client/user-course/source/${params}`);
};

//获取用户某课程
export let getNetUserCourseById = (params) => {
    return axios.get(`/net/client/user-course/${params}`);
};

//初级证书课程授权
export let postNetCourseAuth = (params) => {
    return axios.post(`/net/client/user-course/auth/${params}`);
};

//开始考试
export let getNetBegExam = (params) => {
    return axios.get(`/net/client/exam/begExam/${params.certDictId}/${params.enrollId}`);
};

//申请证书
export let getNetEnrollCert = (params) => {
    return axios.get(`/client/net/enroll/cert/${params}`);
};

//查询证书
export let getNetQueryCert = (params) => {
    return axios.get(`/client/net/user/cert/queryUserCertByEnrollId/${params}`);
};

//查询证书-C端
export let postNetQueryCert = (params) => {
    return axios.post(`/client/net/user/cert/queryCert`, params);
};

//删除报名记录
export let getNetEnrollRemove = (params) => {
    return axios.get(`/net/enroll/enroll/remove/${params}`);
};

//课程中心
export let getNetCourseCenterList = (params) => {
    return axios.post(`net/client/course/center/list`, params);
};



// WEBPACK FOOTER //
// ./src/api/net_cert.js